export default {
  productDetails: [],
  allProductDetails: {},
  perPageState: 10,
  currentPageState: 1,
  searchState: "",
  totalRowsState: 0,
};
